// Server-Aufrufe der Lernhilfen im Spielmodus: Hinweis, Urteil über den eigenen Zug, Eröffnung,
// Vergleich mit dem Partiezug („Spiel wie …“).
import { call } from './api';

export type Judgement = 'inaccuracy' | 'mistake' | 'blunder';

export interface Check {
  judgement: Judgement | null;
  best: string | null;
  bestSan: string | null;
}

/** Zug aus den Partien der Bibliothek mit Ergebnissen (Weiß gewinnt, Remis, Schwarz gewinnt) */
export interface LibraryMove {
  san: string;
  games: number;
  white: number;
  draws: number;
  black: number;
}

export interface Opening {
  eco: string | null;
  name: string | null;
  /** Stellung kommt in einer benannten Linie vor */
  known: boolean;
  next: string[];
  library: { ready: boolean; games: number; moves: LibraryMove[] };
}

/** „Spiel wie …“: Punkte 0 … 10 und Verlust an Gewinnchance (Prozentpunkte) gegenüber dem Partiezug */
export interface GuessScore {
  points: number;
  loss: number;
  cpMaster: number | null;
  mateMaster: number | null;
  cpGuess: number | null;
  mateGuess: number | null;
}

const post = <T>(url: string, body: unknown) => call<T>('POST', url, JSON.stringify(body), true);

export const coachApi = {
  hint: (fen: string) => post<{ best: string | null }>('/api/play/hint', { fen }),
  check: (before: string, after: string) => post<Check>('/api/play/check', { before, after }),
  guess: (before: string, master: string, guess: string) => post<GuessScore>('/api/play/guess', { before, master, guess }),
  opening: (fen: string) => post<Opening>('/api/opening', { fen }),
};
